export default __webpack_public_path__ + "static/media/gallery.45752e9c.svg";